import { Box, Stack, Text } from '@chakra-ui/react';
import { memo } from 'react';

interface SettingItemProps {
  title?: string;
  children: React.ReactNode;
}

const SettingItem = ({ title, children }: SettingItemProps) => {
  return (
    <Box>
      {title && (
        <Text fontSize="xs" fontWeight="medium" py="2.5" color="grey.95">
          {title}
        </Text>
      )}

      <Stack gap="0" rounded={'md'} overflow="hidden">
        {children}
      </Stack>
    </Box>
  );
};

interface SettingSubItemProps {
  title: string | React.ReactNode;
  desc?: string;
  children?: React.ReactNode;
  collapseChildren?: React.ReactNode;
  pointer?: boolean;
  onClick?: () => void;
}

const SettingSubItem = ({
  title,
  desc,
  children,
  collapseChildren,
  pointer,
  onClick,
}: SettingSubItemProps) => {
  return (
    <Box px="1" bg="bg">
      <Box
        py="3.5"
        px="2"
        bg="bg"
        fontSize="sm"
        fontWeight="medium"
        cursor={onClick || pointer ? 'pointer' : 'default'}
        onClick={onClick}
        borderBottom="1px solid"
        borderColor="grey.10"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap="2.5"
      >
        <Stack gap="0.5">
          <Box fontWeight="medium">{title}</Box>
          {desc && (
            <Text
              fontSize="xs"
              fontWeight="normal"
              color={'grey.95'}
              lineHeight="normal"
              alignSelf="stretch"
            >
              {desc}
            </Text>
          )}
        </Stack>
        {children && (
          <Box color="brand" textAlign="right">
            {children}
          </Box>
        )}
      </Box>
      {collapseChildren && collapseChildren}
    </Box>
  );
};

const MemoizedSettingItem = memo(SettingItem);
const MemoizedSettingSubItem = memo(SettingSubItem);

export { MemoizedSettingItem as SettingItem, MemoizedSettingSubItem as SettingSubItem };
